// extracted by mini-css-extract-plugin
export default {"cardSkeleton":"CardSkeleton-module__cardSkeleton__CMnI7"};